module.exports = __webpack_public_path__ + "img/registration-5000.8e0f0dd3.png";